import React from "react";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";
import { AaropiShodha } from "../aaropi_shodha/aaropi_shodha";
//import { ProfessionalForm } from "../ProfessionalForm/ProfessionalForm";
const ProfessionalForm = React.lazy(() =>
   import('../ProfessionalForm/ProfessionalForm').then(module => ({
      default: module.ProfessionalForm
   }))
);
 
 
class FindAccusedPage extends React.Component {
  constructor(props) {
    super(props);
  }
 

  componentDidUpdate(){
    
  }
 
  componentDidMount() {
  }

  
  render() {
    return (
      <div className="col-md-6 col-md-offset-3">
        <React.Suspense fallback={<div>Loading...</div>}>
          {/* {this.props.user?.role === "4" ? <AaropiShodha /> : <AaropiShodha />} */}
          <AaropiShodha/>
          {/* <ProfessionalForm   />  */}
          {/* <AaropiShodha/> */}
        </React.Suspense>
      </div>
    );
  }
}

function mapStateToProps(state) {
    const { users, authentication, professionals } = state;
    const { user } = authentication;
    return {
      user,
      users,
      professionals,
    };
  }

const connectedFindAccusedPage = connect(mapStateToProps)(FindAccusedPage);
export { connectedFindAccusedPage as FindAccusedPage };
